import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true, // necessário quando o backend usa credentials: true no CORS
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
